import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M1.101 24.933h29.797c-.292.856-.894 2.258-2.003 3.534H3.105c-1.11-1.276-1.712-2.678-2.004-3.534M28.9 3.533c1.113 1.269 1.722 2.667 2.02 3.534H16V3.533zM.021 17.8h31.953a34 34 0 0 1-.314 3.533H.325A33 33 0 0 1 .021 17.8m31.662-7.133c.165 1.198.258 2.386.296 3.533H16v-3.533z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "m8 12-1.3 3.205.024-3.459-2.428 2.464 1.347-3.186-3.186 1.347L4.92 9.942l-3.459.025 3.206-1.3-3.206-1.3 3.46.024-2.464-2.428L5.643 6.31 4.296 3.124l2.428 2.463L6.7 2.128 8 5.333l1.3-3.205-.024 3.46 2.428-2.464-1.347 3.186 3.186-1.347L11.08 7.39l3.459-.025-3.206 1.3 3.206 1.301-3.46-.025 2.464 2.428-3.186-1.346 1.347 3.186-2.428-2.464.025 3.46z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagUry = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagUry_default = SvgFlagUry;

export { FlagUry_default as default };
